import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import assignProps from "../../assignProps.mjs";
import pick from "../../pick.mjs";
import logger from "../../logger.mjs";
function assign(target, source) {
  return Object.defineProperties(target, Object.keys(source).reduce(function (descriptors, key) {
    descriptors[key] = Object.getOwnPropertyDescriptor(source, key);
    return descriptors;
  }, {}));
}
export function getterMethodName(name) {
  return "get".concat(name, "Props");
}
export function getterMethodNameByDisplayName() {
  var displayName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var displayNames = displayName.split('.');
  var name = displayNames.slice(-(displayNames.length - 1)).join('');
  return getterMethodName(name);
}
function flatGetterMethodNames(childComponents, parentName) {
  return Object.entries(childComponents).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    if (Array.isArray(value)) {
      acc = [].concat(_toConsumableArray(acc), _toConsumableArray(flatGetterMethodNames(value[1], name)));
    }
    name = parentName ? "".concat(parentName).concat(name) : name;
    acc.push(getterMethodName(name));
    return acc;
  }, []);
}
export var STATIC_COMPONENT = Symbol('STATIC_COMPONENT');
export var ROOT_COMPONENT = Symbol('ROOT_COMPONENT');
var SELF_GETTER_METHOD = Symbol('SELF_GETTER_METHOD');
function Enhancement(childComponents, createComponent, options) {
  var getterMethodNames = flatGetterMethodNames(childComponents);
  return {
    condition: function condition(Component) {
      return Boolean(Component[STATIC_COMPONENT] || Object.keys(childComponents).length);
    },
    init: function init(props, WrapperComponent) {
      var _this = this;
      var getterMethods = pick(this, getterMethodNames);
      this[SELF_GETTER_METHOD] = function () {
        var selfGetterMethod = getterMethodNameByDisplayName(WrapperComponent.displayName);
        logger.warn(true, "Getter `".concat(selfGetterMethod, "` can't be fired as it is a getter of static component"), props['data-ui-name'] || WrapperComponent.displayName);
      };
      assign(this, getterMethodNames.reduce(function (acc, name) {
        var getterMethod = getterMethods[name];
        if (!getterMethod) return acc;
        acc[name] = function () {
          var childrenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var getterProps = getterMethod.call(_this, childrenProps, acc[name].index);
          return assignProps(childrenProps, getterProps);
        };
        acc[name].index = -1;
        acc[name].cache = new Set();
        return acc;
      }, {}));
    },
    "static": function _static(WrapperComponent, Component) {
      if (Object.keys(childComponents).length && !WrapperComponent.displayName) {
        throw new Error('"displayName" is not defined');
      }
      return Object.entries(childComponents).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          name = _ref4[0],
          value = _ref4[1];
        var childComponents = {};
        if (Array.isArray(value)) {
          childComponents = value[1];
          value = value[0];
        }
        var prevStaticComponent = value[STATIC_COMPONENT];
        // @ts-ignore
        var prevDisplayName = value.displayName;
        // @ts-ignore
        value.displayName = "".concat(WrapperComponent.displayName, ".").concat(name);
        value[STATIC_COMPONENT] = true;
        value[ROOT_COMPONENT] = Component[ROOT_COMPONENT] || Component;
        acc[name] = createComponent(value, childComponents, options);
        // @ts-ignore
        value.displayName = prevDisplayName;
        value[STATIC_COMPONENT] = prevStaticComponent;
        return acc;
      }, {});
    },
    context: function context(_context) {
      // const getterMethod = getterMethodNameByDisplayName(WrapperComponent.displayName);
      return _objectSpread(_objectSpread({}, _context), pick(this, getterMethodNames));
    },
    wrapperProps: function wrapperProps(props, WrapperComponent) {
      if (!WrapperComponent[STATIC_COMPONENT]) return props;
      var context = React.useContext(options.context);
      var getterMethod = context[getterMethodNameByDisplayName(WrapperComponent.displayName)];
      if (getterMethod) {
        if (!getterMethod.cache.has(this)) {
          getterMethod.cache.add(this);
          getterMethod.index++;
          if (this) this.index = getterMethod.index;
        }
        if (this) getterMethod.index = this.index;
        return getterMethod(props);
      }
      return props;
    },
    render: function render(_render) {
      var _this2 = this;
      getterMethodNames.forEach(function (name) {
        if (_this2[name] === undefined) return;
        _this2[name].index = -1;
        _this2[name].cache.clear();
      });
      return _render;
    }
  };
}
export default Enhancement;
//# sourceMappingURL=staticChildren.mjs.map